import request from "~/utils/http";

const orderApi = {
    gets: async (params) => {
        const url = 'order';
        return await request.get(url, {params});
    },
    get: async (id) => {
        const url = `order/detail/${id}`;
        return await request.get(url);
    },
    add: async (params) => {
        const url = 'order';
        return await request.post(url, params);
    },
};

export default orderApi;
